var _defs, _g, _path, _g2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewPurchase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.501,
    height: 55,
    viewBox: "0 0 57.501 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#74798c;}.b{fill:#2eb77d;}.c{fill:#fafafa;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 42.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 6.25,
    cy: 6.25,
    rx: 6.25,
    ry: 6.25,
    transform: "translate(25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 6.25,
    cy: 6.25,
    rx: 6.25,
    ry: 6.25
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M132.519,75.093a1.25,1.25,0,0,0-.937-.422h-45a1.25,1.25,0,0,0-1.225,1.5l5,25a1.354,1.354,0,0,0,1.39,1l37.5-5a1.25,1.25,0,0,0,1.075-1.085l2.5-20A1.249,1.249,0,0,0,132.519,75.093Z",
    transform: "translate(-75.331 -67.171)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.506 12.472)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M153.129,135.117a1.25,1.25,0,0,1-1.232-1.045l-2.5-15a1.25,1.25,0,0,1,2.465-.41l2.5,15a1.25,1.25,0,0,1-1.028,1.438A1.2,1.2,0,0,1,153.129,135.117Z",
    transform: "translate(-149.385 -117.589)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M215.791,133.548a1.25,1.25,0,0,1-1.25-1.138l-1.25-13.75a1.25,1.25,0,0,1,1.127-1.362h.01a1.25,1.25,0,0,1,1.357,1.132h0l1.25,13.75a1.25,1.25,0,0,1-1.132,1.358h0Z",
    transform: "translate(-205.797 -117.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M278.583,132.337a1.25,1.25,0,0,1-1.25-1.25v-12.5a1.25,1.25,0,1,1,2.5,0v12.5A1.25,1.25,0,0,1,278.583,132.337Z",
    transform: "translate(-262.339 -117.309)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M331.852,131.038h-.14a1.25,1.25,0,0,1-1.111-1.375v-.013l1.25-11.25a1.267,1.267,0,0,1,1.388-1.112,1.25,1.25,0,0,1,1.105,1.38h0l-1.25,11.25A1.25,1.25,0,0,1,331.852,131.038Z",
    transform: "translate(-309.358 -117.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M385.253,129.624a1.25,1.25,0,0,1-1.213-1.552l2.5-10a1.25,1.25,0,1,1,2.439.549q-.006.028-.014.056l-2.5,10A1.25,1.25,0,0,1,385.253,129.624Z",
    transform: "translate(-356.509 -117.096)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M51.25,50.67H22.4a8.775,8.775,0,0,1-8.58-7.033L7.725,13.17H1.25a1.25,1.25,0,1,1,0-2.5h7.5a1.25,1.25,0,0,1,1.225,1L16.27,43.145A6.268,6.268,0,0,0,22.4,48.17H51.25a1.25,1.25,0,0,1,0,2.5Z",
    transform: "translate(0 -10.67)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPurchase);
export default __webpack_public_path__ + "static/media/NewPurchase.2b1968b891de3ca36edbe3b4e30ea56e.svg";
export { ForwardRef as ReactComponent };